import { ElMessage } from 'element-plus'

let loadingInstance = null

const LoadingMessage = {
    install(app, options = {}) {
        const defaultOptions = {
            message: '加载中...',
            icon: 'Loading',
            duration: 0,
            offset: 72,
            customClass: 'loading-message',
            ...options
        }

        // 添加到全局属性
        app.config.globalProperties.loadingMessage = {
            show(customOptions = {}) {
                // 关闭已存在的提示
                this.hide()

                loadingInstance = ElMessage({
                    ...defaultOptions,
                    ...customOptions
                })

                return loadingInstance
            },

            hide() {
                setTimeout(() => {
                    if (loadingInstance) {
                        loadingInstance.close()
                        loadingInstance = null
                    }
                }, 500);
            }
        }

        // 也可以添加到 app 实例
        app.provide('loadingMessage', app.config.globalProperties.loadingMessage)
    }
}

export default LoadingMessage
